import { Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from "../../shared/pipes/translate.pipe";
import { LanguageService } from "../../shared/services/language.service";
import { HeadlineComponent } from "../../shared/elements/headline/headline.component";
import { IconBadgeComponent } from "../../shared/elements/icon-badge/icon-badge.component";
import { FormInputComponent } from "../../shared/elements/form-input/form-input.component";
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormButtonComponent } from "../../shared/elements/form-button/form-button.component";
import { DialogComponent, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { FormDropdownComponent } from "../../shared/elements/form-dropdown/form-dropdown.component";
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { LinkComponent } from "../../shared/elements/link/link.component";
import { LayoutService } from "../../shared/services/layout.service";
import { TooltipComponent } from "../../shared/elements/tooltip/tooltip.component";
import { DialogService } from "../../shared/services/dialog.service";
import { StepHeaderComponent } from "../../shared/elements/step-header/step-header.component";
import { StepContentComponent } from "../../shared/elements/step-content/step-content.component";
import { FormLabelComponent } from "../../shared/elements/form-label/form-label.component";
import { FormTextareaComponent } from "../../shared/elements/form-textarea/form-textarea.component";
import { FormUserGroupMailComponent } from "../../shared/elements/form-user-group-mail/form-user-group-mail.component";
import { FormCheckboxComponent } from "../../shared/elements/form-checkbox/form-checkbox.component";
import { FormDateTimeComponent } from "../../shared/elements/form-date-time/form-date-time.component";
import { FormDateComponent } from "../../shared/elements/form-date/form-date.component";
import { FormNumericComponent } from "../../shared/elements/form-numeric/form-numeric.component";
import { FormRadioComponent } from "../../shared/elements/form-radio/form-radio.component";
import { ContentComponent } from "../../shared/elements/content/content.component";
import { SliderModule, SliderTickEventArgs, SliderTooltipEventArgs, RatingModule } from '@syncfusion/ej2-angular-inputs';
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { FormSwitchComponent } from "../../shared/elements/form-switch/form-switch.component";
import { DialogDocumentsUploadComponent } from "../../modules/documents/dialog-documents-upload/dialog-documents-upload.component";
import { RouterService } from "../../shared/services/router.service";
import { FileStorageResource } from '../../shared/types/generated/fileStorageResource';
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

@Component({
  selector: 'app-feedback-sd',
  imports: [
    CommonModule,
    DialogModule,
    TranslatePipe,
    HeadlineComponent,
    FormInputComponent,
    FormButtonComponent,
    FormDropdownComponent,
    ToastModule,
    IconBadgeComponent,
    LinkComponent,
    TooltipModule,
    TooltipComponent,
    StepHeaderComponent,
    StepContentComponent,
    FormLabelComponent,
    FormTextareaComponent,
    FormUserGroupMailComponent,
    FormCheckboxComponent,
    FormDateTimeComponent,
    FormNumericComponent,
    FormRadioComponent,
    ContentComponent,
    SliderModule,
    RatingModule,
    FormDateComponent,
    TimePickerModule,
    FormSwitchComponent,
    DialogDocumentsUploadComponent,
      NgSrcImageErrorDirective
  ],
  //providers: [ToolbarService, LinkService, CountService, HtmlEditorService, QuickToolbarService, EmojiPickerService,PasteCleanupService],
  templateUrl: './feedback-sd.component.html',
  styleUrl: './feedback-sd.component.scss'
})
export class FeedbackSDComponent implements OnInit, OnDestroy {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  private languageService = inject(LanguageService);
  dialogService = inject(DialogService);
  private elRef = inject(ElementRef);
  routerService = inject(RouterService);

  @ViewChild('showFeedbackCreate') showFeedbackCreate: DialogComponent | any;
  @ViewChild('showFeedbackPreview') showFeedbackPreview: DialogComponent | any;
  public attachmentFiles: FileStorageResource[] = [];

  repeatOptions: any[] = [{ id: 'onceandexpire', name: this.languageService.getTranslationByKey('SHOWONCE') }, { id: 'daily', name: this.languageService.getTranslationByKey('DAILY') }, { id: 'weekly', name: this.languageService.getTranslationByKey('WEEKLY') }, { id: 'monthly', name: this.languageService.getTranslationByKey('MONTHLY') }, { id: 'yearly', name: this.languageService.getTranslationByKey('YEARLY') }];

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
  }

  /**** FORM GROUP */
  public feedbackForm: FormGroup = this.formBuilder.group({
    search_feedback_string: [''],
    feedbackTileFilter: [],
    feedbackCompletedFilter: [],
    feedbackByUserFilter: [0],
    feedback_title: [''],
    on_date_time_start: [''],
    invitation_message: [''],
    repeatOptions: [''],
    deadline_date: [''],
    hours_before_deadline: [''],
    days_before_deadline: [''],
    reminder_message: [''],
    allow_reatking_feedback: [false],
    inform_via_push: [false],
    email_when_user_completes: [false],
    anonym_feedback: [false],
    is_display_question_number: [true],
    feedback_type: ['optional'],
    create_public_link: [false],
    feedback_public_link: [''],
    question_display_style: ['one_at_a_time'],
    question_title: [''],
    radio_options: [''],
    slider_use_value_as_points: [''],
    feedback_radio_label1: [''],
    feedback_radio_label2: [''],
    requires_comment: [''],
    answer_points: [0],
    correct_answer: [''],
    answer_requires_comment: [''],
    answer_timelimit: [0],
    feedback_question: [''],
    is_logic: ['selected'],
    feedback_logic_value: [''],
    skipto_logic: [''],
    checkbox_option: [''],
    slider_minimum: [0],
    slider_maximum: [1],
    slider_step: [0.1],
    slider_startvalue: [0.3],
    slider_label_large_step_marker: [0.2],
    slider_label_small_step_marker: [0.1],
    slider_show_small_steps: [true],
    slider_show_tooltip: [true],
    slider_unit_text: ['$'],
    slider_unit_onleftside: [false],
    rating_showlabel: [0],
    rating_show_reset: [0],
    rating_allow_half_rates: [0],
    feedback_text: [''],
    dropdown_item: [''],
    feedback_asnwer_label: [''],
    feedback_reordarable_items: [''],
    datetime_answer: [''],
    date_asnwer: [''],
    feedback_score_title: [''],
    feedback_score_description1: [''],
    feedback_score_description2: [''],
    feedback_question_description: [''],
    toggle_branching_score: [false],
    feedback_score_value: [0],
    display_score: [true],
    score_in_percentage: [true],
    score_custom_text: [true],
    feedback_comment: [''],
    feedback_external_link: ['https://stage.max-toolbox.com/intranet/detail/13779153'],
    allow_retaking_feedback: [''],
    summarystats_for_users: ['']
  });
  /**** FORM GROUP END */

  /**** FAKE FUNCTION */
  fakeMethod = (): void => {
    console.log("Fake method");
  }

  /***DIALOGS */
  public visible = false;
  public visible1 = false;
  public activeStep = 0;
  public participantsUserIDs: number[] = [108];
  public participantsGroupIDs: number[] = [8, 6];
  public participantsMails: string[] = [];
  public pushUserIDs: number[] = [];
  pushGroupIDs: number[] = [];
  public steps: string[] = [this.languageService.getTranslationByKey('FEEDBACKTEXTCONTENTMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKTYPESELECTIONMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKAUDIENCEMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKSPLASHMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKATTACHMENTMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKSCHEDULINGMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKRECURRANCEMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKSTATISTICSPERMISSIONSMENUTEXT'), this.languageService.getTranslationByKey('FEEDBACKSETTINGSMENUTEXT')];

  onOpenDialog = (event: any, id: string): void => {
    event.preventDefault();
    if (id == 'create-newfeedback') {
      this.activeStep = 0;
      this.visible = true;
    }
    if (id == 'start-feedbackcomposer') {
      this.showFeedbackCreate!.show();
      //CLOSE THE NEW FEEDBACK DIALOG
      this.closeNewFeedback();
      //CLOSE THE SIDE PANEL
      this.isPanelOpen = false;
      // Ensure sliders refresh when dialog opens. This might be needed in your component inside ngAfterViewInit
      this.refreshSliders();
    }

    if (id == 'start-feedbackpreview') {
      this.showFeedbackPreview!.show();
      // Ensure sliders refresh when dialog opens. This might be needed in your component inside ngAfterViewInit
      this.refreshSliders();
    }

    if (id == 'show-questiontype') {
      this.showQuestionType.show();
    }

    if (id == 'show-answersettings') {
      this.showAnswerSettings.show();
    }

    if (id == 'show-ratingsettings') {
      this.showRatingSettings.show();
    }

    if (id == 'show-slidersettings') {
      this.showSliderSettings.show();
    }

    if (id == 'show-answertimelimit') {
      this.showAnswerTimeLimit.show();
    }

    if (id == 'show-answerlabel') {
      this.showManageAnswerLabel.show();
    }

    if (id == 'show-question-description') {
      this.showManageTitleDescription.show();
    }

    if (id == 'show-logic') {
      this.showLogic.show();
    }
  }

  closeDialog(id = ""): void {
    if (id == 'start-feedbackcomposer') {
      this.showFeedbackCreate!.hide();
    }

    if (id == 'start-feedbackpreview') {
      this.showFeedbackPreview!.hide();
    }

    if (id == 'show-questiontype') {
      this.showQuestionType.hide();
    }

    if (id == 'show-answersettings') {
      this.showAnswerSettings.hide();
    }

    if (id == 'show-ratingsettings') {
      this.showRatingSettings.hide();
    }

    if (id == 'show-slidersettings') {
      this.showSliderSettings.hide();
    }

    if (id == 'show-answerlabel') {
      this.showManageAnswerLabel.hide();
    }

    if (id == 'show-answertimelimit') {
      this.showAnswerTimeLimit.hide();
    }

    if (id == 'show-question-description') {
      this.showManageTitleDescription.hide();
    }

    if (id == 'show-logic') {
      this.showLogic.hide();
    }
  }

  setStep(activeStep: number): void {
    this.activeStep = activeStep;
  }

  save(): void {
    console.log("Fake method");
  }

  closeNewFeedback(): void {
    this.visible = false;
  }

  close(): void {

  }

  public onOpenDialogPreventFocus(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }
  /***END */

  /***** ADMIN/USER MODE SWITCH */
  isAdmin = true;
  selectedCard = 'manage';
  onChangeMode() {
    this.isAdmin = !this.isAdmin;
    this.selectedCard = this.isAdmin ? 'manage' : 'mandatory';
  }
  /**** END */

  /**** ADMIN/USER MAIN MENU CONTENT */

  setSelectedCard(card: string) {
    this.selectedCard = card;
  }

  handleCardKey(event: KeyboardEvent, card: string) {
    console.log(event);
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.setSelectedCard(card);
    }
  }
  /**** END  */

  /**** FILTER OPTIONS FOR FEEDBACK TILES*/
  feedbackTileFilter: any[] = [
    { id: 'all', name: this.languageService.getTranslationByKey('FEEDBACKFILTERALLMENU') },
    { id: 'mandatory', name: this.languageService.getTranslationByKey('FEEDBACKFILTERMANDATORYMENU') },
    { id: 'anonym', name: this.languageService.getTranslationByKey('FEEDBACKFILTERANONYMMENU') },
    { id: 'optional', name: this.languageService.getTranslationByKey('FEEDBACKFILTEROPTIONALMENU') }
  ];

  feedbackCompletedFilter: any[] = [
    { id: 'recent', name: this.languageService.getTranslationByKey('FEEDBACKFILTERBYRECENTMENU') },
    { id: 'alphabetical', name: this.languageService.getTranslationByKey('FEEDBACKFILTERALPAHBETICALMENU') },
    { id: 'mandatory', name: this.languageService.getTranslationByKey('FEEDBACKFILTERMANDATORYMENU') },
    { id: 'anonym', name: this.languageService.getTranslationByKey('FEEDBACKFILTERANONYMMENU') },
    { id: 'optional', name: this.languageService.getTranslationByKey('FEEDBACKFILTEROPTIONALMENU') }
  ];

  feedbackByUserFilter: any[] = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Carsten Jobmann' },
    { id: 2, name: 'Stefan Dragosici' },
    { id: 3, name: 'Beni Blass' },
  ];
  /**** END */

  /**** ADMIN Available tiles */
  imageSrc = "https://www.shutterstock.com/image-vector/survey-form-pencil-vector-illustration-600nw-2656414333.jpg";
  /*** END */

  /**** SIDE PANsEL */
  isPanelOpen = false;

  closePanel() {
    this.isPanelOpen = false;
  }

  openPanel() {
    this.isPanelOpen = true;
  }

  openAttachment() {
    alert('Open the same window as in news for attachment!')
  }
  /**** END */

  /*****Reach text editor
  @ViewChild('rte') rte!: RichTextEditorComponent;
  @ViewChild('emojiButton') emojiBtn!: ElementRef;
  public isEditorEnabled = true;
  maxLength = 1000;
  public value: string = "<p><div>Prevention of Cross Sit Scripting (XSS)</div><script>alert('hi')</script></p>"
  public toolbarSettings: ToolbarSettingsModel = {
        items: ['EmojiPicker', 'Bold', 'Italic', 'Underline', { tooltipText: 'Title', undo: true, click: this.onClick.bind(this), template: '<button type="button" class="e-tbar-btn e-btn e-lib e-icon-btn" tabindex="-1">'
                    + '<span class="e-btn-icon e-caption e-icons"></span></button>' },'|', 'Alignments', 'OrderedList', 'UnorderedList', '|', 'ClearFormat']
  };

  public onClick(event: Event) {
    this.rte!.focusIn();
    const selection = document.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    let parentNode = range.commonAncestorContainer as HTMLElement;
    if (parentNode.nodeType === Node.TEXT_NODE) {
        parentNode = parentNode.parentElement!;
    }

    // Check if the selection is already within an <h5>
    if (parentNode.closest('h5')) {
        // If inside <h5>, remove it (convert to paragraph)
        this.rte.executeCommand('formatBlock', 'P');
    } else {
        // Otherwise, apply <h5>
        this.rte.executeCommand('formatBlock', 'H5');
    }
  }

  toggleEditor() {
    this.isEditorEnabled = !this.isEditorEnabled;
    this.rte.enabled = this.isEditorEnabled;
  }

  public pasteCleanupSettings: PasteCleanupSettingsModel = {
    prompt: false,
    plainText: false,
    keepFormat: false,
    deniedTags: ['div', 'span', 'font', 'style', 'script', 'img', 'table', 'ol'],
    deniedAttrs: ['class', 'style', 'id', 'title'],
    allowedStyleProps: ['font-weight', 'font-style', 'text-decoration']
  };



  public onBeforeSanitizeHtml(e: BeforeSanitizeHtmlArgs): void {
    e.helper = (value: string) => {
        e.cancel = true;
        let temp: HTMLElement = document.createElement('div');
        temp.innerHTML = value;
        let scriptTag: HTMLElement = temp.querySelector('script') as HTMLElement;
        if (scriptTag) {
            detach(scriptTag);
        }
        return temp.innerHTML;
    }
  }

  public openEmojiPicker() {
    if (this.rte && this.rte.emojiPickerModule) {
      // Get the position of the emoji button as a reference
      const buttonPosition = this.emojiBtn.nativeElement.getBoundingClientRect();

      // Manually show the emoji picker at the correct position
      this.rte.showEmojiPicker();
    }
  }*/


  /***** FEEDBACK CREATOR POPUP */
  @ViewChild('showQuestionType') showQuestionType: DialogComponent | any;
  @ViewChild('showAnswerSettings') showAnswerSettings: DialogComponent | any;
  @ViewChild('showRatingSettings') showRatingSettings: DialogComponent | any;
  @ViewChild('showSliderSettings') showSliderSettings: DialogComponent | any;
  @ViewChild('showAnswerTimeLimit') showAnswerTimeLimit: DialogComponent | any;
  @ViewChild('showManageAnswerLabel') showManageAnswerLabel: DialogComponent | any;
  @ViewChild('showManageTitleDescription') showManageTitleDescription: DialogComponent | any;
  @ViewChild('showLogic') showLogic: DialogComponent | any;

  isMandatoryQuestion = true;
  isQuestionExpanded = true;
  isDisabledQuestion = false;
  questionHasAttachments = false;
  thereIsAnImageUploaded = true;
  toggleFeedbackInfo = true;
  showAttachments(): void {
    alert("Display a list of attached files like in the news file attachments.");
  }

  disableQuestion(): void {
    this.isDisabledQuestion = !this.isDisabledQuestion;
  }

  markAsMandatory(): void {
    this.isMandatoryQuestion = !this.isMandatoryQuestion;
  }

  addAttachmentToQuestion(): void {
    this.questionHasAttachments = true;
    alert("Display a file upload window");
  }

  saveFeedbackForm(event: any): void {
    alert("SAVE THE FORM AUTOMATICALLY");
    event.cancel = false;
  }

  toggleExpanded(): void {
    this.isQuestionExpanded = !this.isQuestionExpanded;
  }

  togleFeedbackInfo(): void {
    this.toggleFeedbackInfo = !this.toggleFeedbackInfo;
  }

  is_logic_options: any[] = [
    { id: 'selected', name: this.languageService.getTranslationByKey('FEEDBACKLOGICSELECTEDMENU') },
    { id: 'notselected', name: this.languageService.getTranslationByKey('FEEDBACKLOGICNOTSELECTED') },
    { id: 'greaterthan', name: this.languageService.getTranslationByKey('FEEDBACKLOGICGREATERTHANMENU') },
    { id: 'lessthan', name: this.languageService.getTranslationByKey('FEEDBACKLOGICLESSTHANMENU') },
    { id: 'equalto', name: this.languageService.getTranslationByKey('FEEDBACKLOGICEQUALTOMENU') },
    { id: 'notequalto', name: this.languageService.getTranslationByKey('FEEDBACKLOGICNOTEQUALTOMENU') },
    { id: 'isempty', name: this.languageService.getTranslationByKey('FEEDBACKLOGICISEMPTYMENU') },
    { id: 'notempty', name: this.languageService.getTranslationByKey('FEEDBACKLOGICNOTEMPTYMENU') },
  ];

  skipto_logic_options: any[] = [
    { id: 'q2', name: 'Question 2' },
    { id: 'q3', name: 'Question 3' },
    { id: 'q4', name: 'Question 4' }
  ];

  questionDropdown: any[] = [
    { id: 1, name: "Dropdown item 1" },
    { id: 2, name: "Dropdown item 2" },
    { id: 3, name: "Dropdown item 3" },
    { id: 4, name: "Dropdown item 4" },
    { id: 5, name: "Dropdown item 5" }

  ];

  /*Slider*/
  labelAtStart = false;
  initialValue = 1;
  handleSteps = 0.1;
  minInterval = 0;
  maxInterval = 2
  ticks: object = { placement: 'After', largeStep: 0.2, smallStep: 0.1, showSmallTicks: true };
  tooltip = { placement: 'Before', isVisible: true };

  //this is required because the slider does initializes the values/ranges inside the dialogs, maybe ngAfterViewInit will solve the problem in your case
  refreshSliders() {
    setTimeout(() => {
      const sliders = this.elRef.nativeElement.querySelectorAll('ejs-slider');
      sliders.forEach((slider: any) => {
        if (slider.ej2_instances) {
          slider.ej2_instances[0].refresh();
        }
      });
    }, 100);
  }

  tooltipChangeHandler(args: SliderTooltipEventArgs | any): void {
    if (!this.feedbackForm.get('slider_unit_text')?.value) return;
    if (this.feedbackForm.get('slider_unit_onleftside')?.value) {
      args.text = this.feedbackForm.get('slider_unit_text')?.value + ' ' + parseFloat(args.value);
    } else {
      args.text = parseFloat(args.value) + this.feedbackForm.get('slider_unit_text')?.value;
    }
  }

  renderingTicksHandler(args: SliderTickEventArgs | any): void {
    if (!this.feedbackForm.get('slider_unit_text')?.value) return;
    if (this.feedbackForm.get('slider_unit_onleftside')?.value) {
      args.text = this.feedbackForm.get('slider_unit_text')?.value + (Number(args.value) + 1).toString();
    } else {
      args.text = Number(args.value) + this.feedbackForm.get('slider_unit_text')?.value;
    }
  }

  /*Time Picker*/
  public month: number = new Date().getMonth();
  public fullYear: number = new Date().getFullYear();
  public date: number = new Date().getDate();
  public dateValue: Date = new Date(this.fullYear, this.month, this.date, 10, 0, 0);
  public minValue: Date = new Date(this.fullYear, this.month, this.date, 7, 0, 0);
  public maxValue: Date = new Date(this.fullYear, this.month, this.date, 16, 0, 0);
  public formatString = 'HH:mm';
  public interval = 15;

  /*If Branching Score Switch is toggled*/
  isBranchingScore = true;

  /**** END */

  /*****FEEDBACK PREVIEW */
  isVisibleQuestion = true;

  /***END */


}
